import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("sca_lang") || "pt");

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("sca_lang", l);
  };

  const T = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, T }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
